<template lang="pug">
v-row.py-6.px-1(no-gutters, justify='center')
  v-col
    v-expansion-panels(v-model='panel')
      v-expansion-panel.my-1(v-if='!!about.researchFoci.length')
        person-expansion-header(:title='t("person.researchFoci")', icon='mdi-chart-bar')
        v-expansion-panel-text
          person-research-foci(:researchFoci='about.researchFoci')
      v-expansion-panel.my-1(v-if='!!about.education.length')
        person-expansion-header(:title='t("person.education")', icon='mdi-school')
        v-expansion-panel-text
          v-list-item(v-for='(education, i) in about.education', :key='i')
            person-information-list-item(
              :startDate='education.startDate',
              :endDate='education.endDate',
              :description='education.description'
            )
      v-expansion-panel.my-1(v-if='!!about.positions.length')
        person-expansion-header(:title='t("person.positions")', icon='mdi-format-list-bulleted')
        v-expansion-panel-text
          v-list-item(v-for='(position, i) in about.positions', :key='i')
            person-information-list-item(
              :startDate='position.startDate',
              :endDate='position.endDate',
              :description='position.description'
            )
      v-expansion-panel.my-1(v-if='!!about.appointments.length')
        person-expansion-header(:title='t("person.appointments")', icon='mdi-account-star')
        v-expansion-panel-text
          v-list-item(v-for='(appointment, i) in about.appointments', :key='i')
            person-information-list-item(
              :startDate='appointment.date',
              :description='appointment.description'
            )
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { About } from '~/models/about'

defineOptions({
  name: 'AboutTab',
})

const props = defineProps({
  about: {
    type: Object as () => About,
    required: true,
  },
})

const panel = ref(0)
const { t } = useI18n()
</script>
